import AnalyticsInstance from '@shared/utils/analytics';
import { appSelector } from '@shared/store/slices/app.slice';
import { clearStack } from '@shared/store/slices/router.slice';
import { pause, play, setPosition } from '@shared/store/slices/media.slice';
import { store } from '@shared/store/store';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { useEffect } from 'react';

// Check app visibility and clear stack or reset content

export default function useVisibility() {
  const dispatch = useAppDispatch();
  const {
    status: { visibility },
  } = useAppSelector(appSelector);

  useEffect(() => {
    const { media } = store.getState();
    if (!visibility) {
      dispatch(clearStack());
      dispatch(pause());
      AnalyticsInstance.getOmnitrackManager()?.setAppToBackground();
    } else {
      AnalyticsInstance.getOmnitrackManager()?.setAppToForeground();
      if (media.live) {
        dispatch(play());
        setTimeout(() => {
          dispatch(setPosition({ position: Date.now(), seek: true }));
        });
      }
    }
  }, [visibility]);

  return null;
}
